export default function() {
  return name => {
    let approvalObj = {
      qas: 'QAS',
      irs: 'IRS',
      nationalregistry: 'National Registry',
      allothers: 'All Others',
      illnois: 'Illnois',
      texas: 'Texas',
      newjersey: 'New Jersey',
      newyork: 'New York',
      pennsylvania: 'Pennsylvania'
    };

    if (typeof name === 'string') return approvalObj[name.toLowerCase()] || '';
    return name;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/Approval.js